import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ISeoTagType } from '@app/shared/services/seo/seo-tag-type.enum';
import { SEOService } from '@app/shared/services/seo/seo.service';

@Component({
  selector: 'app-customer-registration-success',
  templateUrl: './customer-registration-success.component.html',
  styleUrls: ['./customer-registration-success.component.scss']
})

export class CustomerRegistrationSuccessComponent implements OnInit {

  private returnUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private seoService: SEOService
  ) {
    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'AUTH.CREATE-ACCOUNT-SUCCESS.META-TITLE'
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: 'AUTH.CREATE-ACCOUNT-SUCCESS.META-DESCRIPTION'
      }
    ]);
  }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  goToCustomerAccount(): void {
    this.router.navigate(['account', 'visits']);
  }

  goBack(): void {
    this.router.navigateByUrl(this.returnUrl);
  }

}
